import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect, useRef, useMemo } from "react";

const Html5QrcodePlugin = ({
  fps = 10,
  qrbox = 250,
  aspectRatio,
  disableFlip,
  verbose = false,
  qrCodeSuccessCallback,
  qrCodeErrorCallback,
  className,
  regionId = "html5qr-code-full-region",
  stopOnScan = true,
}) => {
  const scannerRef = useRef(null);

  const config = useMemo(
    () => ({
      fps,
      qrbox,
      ...(aspectRatio && { aspectRatio }),
      ...(disableFlip !== undefined && { disableFlip }),
    }),
    [fps, qrbox, aspectRatio, disableFlip]
  );

  useEffect(() => {
    if (!qrCodeSuccessCallback) {
      throw new Error("qrCodeSuccessCallback is required.");
    }

    // create scanner instance
    const scanner = new Html5QrcodeScanner(regionId, config, verbose);
    scannerRef.current = scanner;

    const onSuccess = async (decodedText, decodedResult) => {
      qrCodeSuccessCallback(decodedText, decodedResult);

      if (stopOnScan) {
        try {
          await scanner.clear();
          console.log("✅ Scanner stopped after first successful scan.");
        } catch (err) {
          console.error("Failed to clear scanner:", err);
        }
      }
    };

    scanner.render(onSuccess, qrCodeErrorCallback);

    return () => {
      if (scannerRef.current) {
        scannerRef.current
          .clear()
          .catch((error) =>
            console.error("Failed to clear html5QrcodeScanner:", error)
          );
      }
    };
  }, [regionId, config, verbose, qrCodeSuccessCallback, qrCodeErrorCallback, stopOnScan]);

  return <div className={className} id={regionId} />;
};

export default Html5QrcodePlugin;